// Audience values retain the API's units (thousands of viewers).
export function teamAudienceRankings(games, { conference = 'all', team = 'all', minGames = 1, allowedTeams } = {}) {
  const groups = new Map();
  for (const game of games) {
    if (game.viewers == null || !Number.isFinite(Number(game.viewers)) || Number(game.viewers) < 0) continue;
    for (const side of [1, 2]) {
      const name = game[`team${side}`];
      const league = game[`team${side}_conference`];
      if (!name || (side === 2 && name === game.team1)) continue;
      if (allowedTeams && !allowedTeams.includes(name)) continue;
      if (conference !== 'all' && league !== conference) continue;
      if (team !== 'all' && name !== team) continue;
      if (!groups.has(name)) groups.set(name, { team: name, conference: league, audiences: [] });
      groups.get(name).audiences.push(Number(game.viewers));
    }
  }
  return [...groups.values()].filter(row => row.audiences.length >= Math.max(1, Number(minGames) || 1)).map(row => {
    const values = row.audiences.sort((a, b) => a - b);
    const mid = Math.floor(values.length / 2);
    const total = values.reduce((sum, value) => sum + value, 0);
    return { team: row.team, conference: row.conference, games: values.length,
      total, average: total / values.length,
      median: values.length % 2 ? values[mid] : (values[mid - 1] + values[mid]) / 2 };
  }).sort((a, b) => b.average - a.average || b.median - a.median || a.team.localeCompare(b.team))
    .map((row, index) => ({ ...row, rank: index + 1 }));
}

// Preserve average rank while users explore other columns.
export function sortTeamAudienceRankings(rows, key = 'average', direction = 'desc') {
  const sign = direction === 'asc' ? 1 : -1;
  return [...rows].sort((a, b) => {
    const comparison = ['team', 'conference'].includes(key)
      ? String(a[key] || '').localeCompare(String(b[key] || ''))
      : a[key] - b[key];
    return sign * comparison || a.rank - b.rank;
  });
}
